import React, { Component } from 'react'
import { Alert, Container, Row, Col, Form, Card, Button } from 'react-bootstrap'
import { Redirect } from 'react-router-dom'
import { PropTypes } from 'prop-types'
import { connect } from 'react-redux'

import PageTitle from "./../../components/common/PageTitle";
import auth from '../../components/common/Auth';
import history from '../../history';
import { BusinessDBAPI, EnginesAPI } from '../../components/apis';
import { isIP, isPort, isNumber, isAlphanumericSpace, isAlphanumericWithSpecials } from '../../components/common/Util'

class NewBusinessDB extends Component {

  constructor(props, context) {
    super(props, context)
    this.props = props;
    let idAccount = this.props.idAccount;
    this.state = {
      loading: false,
      loadingEngines: false,

      account_id: idAccount,
      engines: [],
      
      enabled: true,
      engine_id: "",
      name: "",
      database_name: "",
      database_modifiers: "", //database_modifiers: " ",
      database_sanity_check: "select 1",
      database_connection_timeout: 60,
      database_host: "",
      database_port: "",
      database_user_name: "",
      database_password: "",
      database_driver: "",
      database_catalog: "",
      database_schema: "",
      minconn: 1,
      maxconn: 10,
      reformatter: "",
      database_urlformat: "",

      goToBusinessDB: false,
      apiErr: null,
      formValidated: true,
    }
    this.data = {
      enabled: false,
    }
    this.api = new BusinessDBAPI(auth.getAccessToken(), idAccount);
  }

  // Set or erase an error message on apiErr state variable
  showErrorMessage (showMessage, message) {

    if (showMessage === true) {
      this.setState({
        formValidated: false,
        apiErr: (showMessage)?message:"",
      })
    } else {
      this.setState({
        formValidated: true,
        apiErr: "",
      })
    }

    // Return true if exists an error, otherwise return false.
    return showMessage;
  }



  handleChange = (field, event) => {

    const fieldValue = event.target.value;
    
    switch (field) {
      case "enabled":
        // "enabled" field must parse as boolean and not as a "string boolean"
        this.setState({
          ...this.state,
          [field]: event.target.checked,
        })
        break;
      case "engine_index":
        let engineFilter = this.state.engines.filter( (engine) => {
          return engine.id === Number(event.target.value);
        });
        if (engineFilter[0]) {
          this.setState({
            "engine": engineFilter[0],
            "engine_id": engineFilter[0].id,
            "database_urlformat": engineFilter[0].database_urlformat,
            "formValidated": true,
            "apiErr": null,
          })
        } else {

          this.setState({
            "engine": "",
            "engine_id": "",
            "database_urlformat": "",
            "formValidated": false,
            "apiErr": this.context.t('DB Engine must be selected'),
          })
        }
        break;
      case "name":
        if (fieldValue === "" || isAlphanumericSpace(fieldValue)){
          this.setState({[field]: fieldValue})
        }
        break;
      case "database_name":
        if (fieldValue === "" || isAlphanumericWithSpecials(fieldValue)){
          this.setState({[field]: fieldValue})
        }
        break;
      case "database_connection_timeout":
        if (fieldValue === "" || (Number(fieldValue) && Number(fieldValue) < 1000)){
          this.setState({[field]: fieldValue})
        }
        break;
      case "minconn":
        if ((fieldValue === "" || Number(fieldValue)) && Number(fieldValue) <= 20){
          this.setState({[field]: fieldValue})
        }
        break;
      case "maxconn":
        if ((fieldValue === "" || Number(fieldValue)) && Number(fieldValue) <= 20){
          this.setState({[field]: fieldValue})
        }
        break;
      case "database_port":
        if (fieldValue === "" || isPort(fieldValue)){
          this.setState({[field]: fieldValue})
        }
        break;
      default:
        this.setState({[field]: fieldValue})
        break;
    } 
  }

  handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;
    const id = this.props.id;
    const self = this;
    
    const minconn = document.getElementById("minconn").value;
    const maxconn = document.getElementById("maxconn").value;


    // Check all filed validations before submit form in order to avoid errors into backend
    if ( (form.checkValidity() === false || this.state.formValidated === false) 
          || this.showErrorMessage( !isIP(document.getElementById("database_host").value), this.context.t(`IP Host value is incorrect`))
          || this.showErrorMessage( !isPort(document.getElementById("database_port").value), this.context.t(`Port value is incorrect`))
          || this.showErrorMessage( !((isNumber(minconn) && Number(minconn) > 0 && Number(minconn) <= 20)), this.context.t(`Minimum number of connections must be a number between 1 and 20`))
          || this.showErrorMessage( !((isNumber(maxconn) && Number(maxconn) > 0 && Number(maxconn) <= 20)), this.context.t(`Max number of connections must be a number between 1 and 20`))
          || this.showErrorMessage( !(Number(maxconn) >= Number(minconn)), this.context.t(`The minimum connections cannot be higher than the maximum connections`))
      ) {
      this.setState({
        formValidated: false,
      })
      return;
    }

    this.setState({
      loading: true
    })


    const businessdb = {
        "id": id,
        "account_id": this.state.account_id,
        "engine_id": this.state.engine.id,
        "name": this.state.name,
        "database_host": this.state.database_host,
        "database_port": this.state.database_port,
        "database_name":  this.state.database_name,
        "database_modifiers": this.state.database_modifiers || this.state.database_modifiers === "" ? this.state.database_modifiers : " ",
        "database_sanity_check": this.state.database_sanity_check,
        "database_connection_timeout": this.state.database_connection_timeout,
        "database_user_name": this.state.database_user_name,
        "database_password": this.state.database_password,
        "database_driver": this.state.engine.driver,
        "database_catalog": this.state.database_catalog ? this.state.database_catalog : " ",
        "database_schema": this.state.database_schema ? this.state.database_schema : " ",
        "maxconn": this.state.maxconn,
        "minconn": this.state.minconn,
        "reformatter": this.state.engine.reformatter,
        "enabled": this.state.enabled,
        "database_urlformat": this.state.database_urlformat
    }

     this.api.create(businessdb).then(() => {
      self.setState({
         loading: false,
         loadingEngines: false,
         goToBusinessDB: true
      })
     }).catch(err => {
        debugger
        self.setState({
          loading: false,
          apiErr: err.response.data.message,
        })
     });
  }

  componentDidMount () {
    this._getEngines()
  }

  _getEngines() {
    const token = auth.getAccessToken()
    const enginesAPI = new EnginesAPI(token);

    this.setState({
      loadingEngines: true,
    });

    const self = this;

    enginesAPI.getAll().then(engines => {

      self.setState({
        loadingEngines: false,
        engines: engines,
      })
      // if (engines.length > 0) {
      //   setTimeout(self.loadTable, 200);
      // }
    }).catch(err => {
      self.setState({
        loadingEngines: false,
        apiErr: err,
      })
    });
  }


  goBack = () => {
    history.goBack();
  }

  render = () => {
    var idAccount = this.props.idAccount;
    var engines = this.state.engines;

    // if (auth.isAuthenticated()) {
      if (this.state.loading && this.state.loadingEngines) {
        return (
          <div>
            <Container fluid>
              <br />
              <div className="container center">
                <h5><i className="fas fa-spinner fa-pulse"></i> {this.context.t('Loading...')}</h5>
              </div>
            </Container>
          </div>
        )
      }

      var redirect = '/accounts/' + idAccount;

      if (this.state.goToBusinessDB) {
        return <Redirect to={redirect} />
      }

      let error
      if (this.state.apiErr) {
        error = (
          <Container fluid className="px-0">
            <Alert
              dismissible={this.dismiss}
              open={this.state.alertVisible}
              className="mb-0 backgrou bg-primary text-white"
            >
              <i className="material-icons">error</i>{" "}
              {this.context.t("There was a mistake")}: {this.state.apiErr}
            </Alert>
          </Container>
        );
      }

      return (
        <div>
          {error}

          <Container fluid>
            <Row noGutters className="page-header py-4">
              <PageTitle
                title={this.context.t("Business Database")}
                subtitle={this.context.t("Add")}
                className="text-sm-left mb-3"
              />
            </Row>

            <Card small="true" style={{ marginBottom: "20px" }}>
              <Form
                validate="true"
                onSubmit={(e) => this.handleSubmit(e)}
                style={{ padding: "10px" }}
                autoComplete="off"
              >
                <Row>
                  <Col lg="6">
                    <Form.Group className="mb-3" controlId="enabled">
                      <Form.Check
                        type="checkbox"
                        checked={this.state.enabled}
                        onChange={(e) => { this.handleChange("enabled", e)}}
                        label={this.context.t("Enabled")}
                      />
                    </Form.Group>
                    <Form.Group controlId="name">
                      <Form.Label>{this.context.t("Name")}</Form.Label>
                      <Form.Control type='text' placeholder={this.context.t('Name')} value={this.state.name} onChange={e => { this.handleChange('name', e) }} required />
                    </Form.Group>

                    <Form.Group controlId='database_name'>
                      <Form.Label>{this.context.t('Name of Business DB')}</Form.Label>
                      <Form.Control type='text' placeholder={this.context.t('Name of Business DB')} value={this.state.database_name} onChange={e => { this.handleChange('database_name', e) }} required />
                    </Form.Group>

                    <Form.Group controlId='database_host'>
                      <Form.Label>{this.context.t('IP Host')}</Form.Label>
                      <Form.Control type='text' value={this.state.database_host} placeholder="192.168.1.17" onBlur={e => { this.showErrorMessage( !isIP(e.target.value), this.context.t(`IP Host value is incorrect`))}} onChange={e => { this.handleChange('database_host', e) }} required />
                    </Form.Group>

                    <Form.Group controlId='database_port'>
                      <Form.Label>{this.context.t('Port')}</Form.Label>
                      <Form.Control type='text' value={this.state.database_port} placeholder="4100" onBlur={e => { this.showErrorMessage( !isPort(e.target.value), this.context.t(`Port value is incorrect`))}} onChange={e => { this.handleChange('database_port', e) }} required />
                    </Form.Group>

                    <Form.Group controlId='database_user_name'>
                      <Form.Label>{this.context.t('User Name')}</Form.Label>
                      <Form.Control type='text' value={this.state.database_user_name} placeholder={this.context.t('User Name')} onChange={e => { this.handleChange('database_user_name', e) }} required />
                    </Form.Group>

                    <Form.Group controlId='database_password'>
                      <Form.Label>{this.context.t('Password')}</Form.Label>
                      <Form.Control type='password' value={this.state.database_password} onChange={e => { this.handleChange('database_password', e) }} />
                    </Form.Group>

                    <Form.Group controlId='database_modifiers'>
                      <Form.Label>{this.context.t('Database Modifiers')} ({this.context.t('Optional')})</Form.Label>
                      <Form.Control type='text' value={this.state.database_modifiers} placeholder="" onChange={e => { this.handleChange('database_modifiers', e) }} />
                    </Form.Group>
                  </Col>
                  <Col lg="6">
                  <Form.Group controlId='engine_id'>
                    <Form.Label>{this.context.t('Relationship Database Provider')}</Form.Label>
                    <Form.Control as="select"
                      value={this.state.engine_id}
                      size="sm"
                      onChange={e => { this.handleChange('engine_index', e) }}>
                      
                      <option value="">--{this.context.t('Engines')}--</option>
                      {engines && engines.length > 0 ? engines && engines.map((engine, index) => {
                        return (
                          <option key={engine.id} value={engine.id}>{engine.name}</option>
                        )
                      }) : null}
                    </Form.Control>
                  </Form.Group>

                  <Form.Group controlId='database_schema'>
                    <Form.Label>{this.context.t('Schema')} ({this.context.t('Optional')})</Form.Label>
                    <Form.Control type='text' value={this.state.database_schema} placeholder="public" onChange={e => { this.handleChange('database_schema', e) }} />
                  </Form.Group>

                  <Form.Group controlId='database_catalog'>
                    <Form.Label>{this.context.t('Catalog')} ({this.context.t('Optional')})</Form.Label>
                    <Form.Control type='text' value={this.state.database_catalog} placeholder="public" onChange={e => { this.handleChange('database_catalog', e) }} />
                  </Form.Group>

                  <Form.Group controlId="database_sanity_check">
                    <Form.Label>{this.context.t('Sanity Check')} ({this.context.t('Optional')})</Form.Label>
                    <Form.Control type='text' value={this.state.database_sanity_check} placeholder="sanity check command" onChange={e => { this.handleChange('database_sanity_check', e) }} />
                  </Form.Group>

                  <Form.Group controlId='database_connection_timeout'>
                    <Form.Label>{this.context.t('Connection Timeout')}</Form.Label>
                    <Form.Control type='text' value={this.state.database_connection_timeout} placeholder="" onChange={e => { this.handleChange('database_connection_timeout', e) }} required />
                  </Form.Group>

                  <Form.Group controlId='database_urlformat'>
                    <Form.Label>{this.context.t('Connection URL')}</Form.Label>
                    <Form.Control type='text' value={this.state.database_urlformat} placeholder="" onChange={e => { this.handleChange('database_urlformat', e) }} required />
                  </Form.Group>

                  <Form.Group controlId='minconn'>
                    <Form.Label>{this.context.t('Minimum Connections')}</Form.Label>
                    <Form.Control type='text' value={this.state.minconn} placeholder="1" onBlur={e => { this.showErrorMessage( !isNumber(e.target.value), this.context.t(`Minimum number of connections must be a number`))}} onChange={e => { this.handleChange('minconn', e) }} required/>
                  </Form.Group>

                  <Form.Group controlId='maxconn'>
                    <Form.Label>{this.context.t('Maximum Connections')}</Form.Label>
                    <Form.Control type='text' value={this.state.maxconn} placeholder="20" onBlur={e => { this.showErrorMessage( !isNumber(e.target.value), this.context.t(`Max number of connections must be a number`))}} onChange={e => { this.handleChange('maxconn', e) }} required />
                  </Form.Group>
                </Col>
                </Row>
                <hr />
                <Button variant="outline-primary mb-2 mr-1" type='submit'>{this.context.t('Save')}</Button>
                &nbsp;
                <Button variant="outline-secondary mb-2 mr-1" onClick={this.goBack}>{this.context.t('Cancel')}</Button>
              </Form>
            </Card>
          </Container>
        </div>
      );
    // } else {
    //   return <Redirect to='/' />
    // }
  }
}

NewBusinessDB.contextTypes = {
  t: PropTypes.func.isRequired
}

export default connect(state => ({
  lang: state.i18nState.lang
}))(NewBusinessDB)
